import { useStaticQuery, graphql } from 'gatsby'

export const getAboutHeroData = () => {
  const { allStrapiCommonHero } = useStaticQuery(aboutHeroDataQuery)
  let aboutHeroData = allStrapiCommonHero.nodes[0].Heros.filter(
    value => Object.keys(value).length !== 0
  )
  return aboutHeroData[0]
}

const aboutHeroDataQuery = graphql`
  query {
    allStrapiCommonHero {
      nodes {
        Heros {
          ... on STRAPI__COMPONENT_SHARED_ABOUT_HERO {
            id
            button {
              id
              name
              url
            }
            description {
              data {
                description
              }
            }
            title
          }
        }
      }
    }
  }
`
